export default Object.freeze({
	LOGIN_CHECK_KEY: 'LOGIN_CHECK',
	USER_PERMISSIONS_KEY: 'USER_PERMISSIONS_KEY',
	USER_INFO_KEY: 'USER_INFO_KEY',
	MERCHANT_LIST_KEY: 'MERCHANT_LIST_KEY',
	MERCHANT_PROFILE_KEY: 'MERCHANT_PROFILE_KEY',
	USER_GROUPS_LIST_KEY: 'USER_GROUPS_LIST_KEY',
	NOTIFICATION_CLOSED: 'NOTIFICATION_CLOSED',
	SELECTED_MID: 'SELECTED_MID',
	INDIAN_MOBILE_REGEX: /^[5-9]\d{9}$/,
	INTERNATIONAL_MOBILE_NUMBER_REGEX: /^\+[1-9](-?\d){6,14}$/,
	MOBILE_REGEX: /^[5-9]\d{9}$/,
	FLOAT_NUMBER_REGEX: /^\d*(?:\.\d*)?$/,
	MAX_NUMBER_PRECISION_REGEX: /^\d+(\.\d{0,2})?$/,
	EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
	PINCODE_REGEX: /^[1-9]\d{5}$/,
	OTP_REGEX: /\b\d{5}\b/g,
	PASSWORD_REGEX: /^.{8,}$/,
	API_WEB_BASE_URL: process.env.REACT_API_WEB_BASE_URL!,
	API_BASE_URL: process.env.REACT_API_BASE_URL,
	API_TEST_MODE_BASE_URL: process.env.REACT_API_TEST_MODE_BASE_URL,
	TICKETS_BASE_URL: process.env.TICKETS_BASE_URL,
	REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
	BUILD_TIMESTAMP: process.env.BUILD_TIMESTAMP,
	BRANCH_NAME: process.env.BRANCH_NAME,
	BUILD_NUMBER: process.env.BUILD_NUMBER!,
	BUILD_ENVIRONMENT: process.env.BUILD_ENVIRONMENT,
	GENERATE_REPORT_DIFF_IN_DAYS: 396,
	HEADERS: {
		'content-type': 'application/json',
		'X-APP-ID': 'oculus',
		NAMESPACE: 'insights',
		'X-SOURCE-PLATFORM': 'WEB',
		'X-SOURCE-TYPE': 'WEB',
		'X-DEVICE-FINGERPRINT': 123,
	},
	TEST_CLIENT_HEADERS: {
		'content-type': 'application/json',
		'X-SOURCE-TYPE': 'WEB',
	},
	API_TIMEOUT: 10000,
	RECENT_SETTLEMENTS_START_TIMESTAMP: 1664562600000, // timestamp - 1st Oct 2022 00:00:00:000
	UNAUTHORISED_CODE: 401,
	UNAUTHORISED_EXCEPTION_URLS: [
		'/qrpos/verify/QR_CODE/',
		'/v1/verify/',
		'/v1/user/setPassword',
		'/v1/gandalf/user/setPassword',
	],
	DESTINATION_URL: 'DESTINATION_URL',
	ONLINE_BUSINESS_UNIT: 'ONLINE',
	OFFLINE_MERCHANT_TYPES: [
		'OFFLINE_UNORGANISED',
		'OFFLINE_ORGANISED',
		'OFFLINE_BUSINESS_ENTITY',
		'OFFLINE_THROUGH_AGGREGATOR',
	],
	ONLINE_MERCHANT_TYPES: [
		'ONLINE_BUSINESS_ENTITY',
		'ONLINE_MERCHANT',
		'ONLINE_AGGREGATOR',
		'ONLINE_THROUGH_AGGREGATOR',
	] as const,
	ONLINE_MERCHANT: 'ONLINE_MERCHANT',
	ONLINE_PAYLINK_STATE_VARIANTS: {
		ACTIVE: 'info',
		CREATED: 'disabled',
		CANCELLED: 'error',
		FAILED: 'error',
		EXPIRED: 'warning',
		COMPLETED: 'success',
		ERRORED: 'disabled',
	} as Record<string, string>,
	ONLINE_PAYLINK_STATES: {
		CREATED: 'CREATING',
		ACTIVE: 'ACTIVE',
		CANCELLED: 'CANCELLED',
		FAILED: 'FAILED',
		EXPIRED: 'EXPIRED',
		COMPLETED: 'COMPLETED',
		ERRORED: 'ERRORED',
	} as Record<string, string>,
	ONLINE_PAYLINK_TERMINAL_STATES: [
		'CANCELLED',
		'FAILED',
		'EXPIRED',
		'COMPLETED',
		'ERRORED',
	],
	OFFLINE_MERCHANT: 'OFFLINE_MERCHANT',
	STATUSES: {
		ACTIVE: 'ACTIVE',
		COMPLETED: 'COMPLETED',
		PENDING: 'PENDING',
		ERRORED: 'ERRORED',
		CANCELLED: 'CANCELLED',
		FAILED: 'FAILED',
		DEEMED: 'DEEMED',
	},
	INSTRUMENTS: {
		DEBIT_CARD: 'DEBIT_CARD',
		CREDIT_CARD: 'CREDIT_CARD',
		ACCOUNT: 'ACCOUNT',
		WALLET: 'WALLET',
		NET_BANKING: 'NET_BANKING',
		EXTERNAL_WALLET: 'EXTERNAL_WALLET',
		OTHERS: 'OTHERS',
	},
	PAYLINK_STATUSES: ['CREATED', 'PAID', 'CANCELLED', 'EXPIRED', 'FAILED'],
	PAYLINK_TRANSACTION_TYPE: 'PAYLINK_META_ENTITY',
	PERMISSIONS: {
		trend_transaction_access: 'trend_transaction_access',
		transaction_access: 'transaction_access',
		refund_list_access: 'refund_list_access',
		cashback_list_access: 'cashback_list_access',
		search_transaction_access: 'search_transaction_access',
		refund_access: 'refund_access',
		settlements_access: 'settlements_access',
		settlementreports_access: 'settlementreports_access',
		reports_access: 'reports_access',
		profile_access: 'profile_access',
		qrcodes_access: 'qrcodes_access',
		qrcode_add_mobile_access: 'qrcode_add_mobile_access',
		qrcode_remove_mobile_access: 'qrcode_remove_mobile_access',
		users_access: 'users_access',
		users_add_access: 'users_add_access',
		users_edit_access: 'users_edit_access',
		batch_recon_access: 'batch_recon_access',
		batch_refund_access: 'batch_refund_access',
		downtime_access: 'downtime_access',
		master_settlement_reports_access: 'master_settlement_reports_access',
		store_update_access: 'store_update_access',
		store_access: 'store_access',
		help_desk_view_access: 'help_desk_view_access',
		transaction_reports_access: 'transaction_reports_access',
		qmc_report_access: 'qmc_report_access',
		app_details: 'app_details',
		apps_list: 'apps_list',
		merchant_support_create_ticket: 'merchant_support_create_ticket',
		merchant_migration_p2ml: 'merchant_migration_p2ml',
		merchant_profile_update: 'merchant_profile_update',
		qr_update_access: 'qr_update_access',
		view_batch_refund_access: 'view_batch_refund_access',
		refund_reports_access: 'refund_reports_access',
		app_creation_maker: 'app-creation-maker',
		app_review_maker: 'app-review-maker',
		app_release_maker: 'app-release-maker',
		app_update_maker: 'app-update-maker',
		online_merchant_onboarding: 'onlineMerchantOnboarding',
		paylink_read_access: 'paylink_read_access',
		paylink_create_access: 'paylink_create_access',
		paylink_update_access: 'paylink_update_access',
		PAYLINK_READ_ACCESS: 'PAYLINK_READ_ACCESS',
		PAYLINK_MANAGE_ACCESS: 'PAYLINK_MANAGE_ACCESS',
		OMX_CONFIG_UPDATE: 'OMX_CONFIG_UPDATE',
		PRIVATE_KEY_READ_ACCESS: 'PRIVATE_KEY_READ_ACCESS',
	},
	P2P_PERMISSIONS: {
		trend_transaction_access: true,
		transaction_access: true,
		refund_list_access: false,
		cashback_list_access: true,
		search_transaction_access: true,
		refund_access: false,
		settlements_access: false,
		settlementreports_access: false,
		reports_access: true,
		profile_access: true,
		qrcodes_access: true,
		qrcode_add_mobile_access: true,
		qrcode_remove_mobile_access: true,
		pos_access: true,
		pos_add_mobile_access: true,
		pos_remove_mobile_access: true,
		users_access: true,
		users_add_access: true,
		users_edit_access: true,
		batch_recon_access: false,
		batch_refund_access: false,
		request_pos_access: false,
		downtime_access: true,
		master_settlement_reports_access: false,
		support_access: false,
		store_update_access: true,
		store_access: true,
		help_desk_view_access: true,
		transaction_reports_access: true,
		app_details: true,
		apps_list: true,
		merchant_support_create_ticket: true,
		merchant_migration_p2ml: true,
		merchant_profile_update: true,
		qr_update_access: true,
		view_batch_refund_access: false,
		refund_reports_access: true,
	},
	P2P_MERCHANT: 'P2P_MERCHANT',
	REFUND_REQUEST_ID: 'requestId',
	REFUND_REPORT_TYPE: 'Refunds',
	REFUND_TRANSACTION_TYPE: 'REFUND_TRANSACTION',
	P2M_LIMITED: 'P2M_LIMITED',
	INSTRUMENT_MAPPING: {
		WALLET: 'Wallet',
		CREDIT_CARD: 'Credit Card',
		DEBIT_CARD: 'Debit Card',
		NET_BANKING: 'Net Banking',
		ACCOUNT: 'UPI',
		EXTERNAL_WALLET: 'External Wallet',
		CREDIT_LINE: 'Credit Line',
		EGV: 'EGV',
	},
	PRODUCT_TYPE_MAPPING: {
		EXPRESSBUY: 'Checkout',
		B2BPG: 'Payment Gateway',
	},
	PAGE_SIZE: 20,
	MAP_MY_INDIA_BASE_URL: `https://apis.mapmyindia.com/advancedmaps/v1/${process.env.REACT_APP_MAP_MY_INDIA_REST_TOKEN}/map_load?v=01.`,
	DOCSTORE_URL: process.env.REACT_APP_DOCSTORE_URL,
	BANK_LOGO_SUB_URL: '/banks',
	SAMPLE_DOWNLOAD_FILE_DETAIL: [
		{
			field: 'merchant_id',
			options: 'mandatory',
			description: 'Registered merchant id at PhonePe',
		},
		{
			field: 'refund_transaction_id',
			options: 'optional',
			description: 'Unique transaction id for the refund transaction',
		},
		{
			field: 'amount',
			options: 'mandatory',
			description: 'Amount to be refunded in Rupees',
		},
		{
			field: 'provider_reference_id',
			options: 'mandatory if merchant_forward_transaction_id is not provided',
			description: 'PhonePe reference id of the forward transaction',
		},
		{
			field: 'merchant_forward_transaction_id',
			options: 'mandatory if provider_reference_id is not provided',
			description: 'Merchant transaction id of the forward transaction',
		},
		{
			field: 'merchant_order_id',
			options: 'mandatory',
			description: 'Order id associated with the refund transaction',
		},
		{
			field: 'Refund Reason',
			options: 'mandatory',
			description: 'Reason for the refund transaction.',
		},
		{
			field: 'merchant_forward_transaction_id',
			options: 'mandatory if provider_reference_id is not provided',
			description: 'Merchant transaction id of the forward transaction',
		},
		{
			field: 'provider_id',
			options: 'optional',
			description:
				'The aggregator id assigned by PhonePe. This is applicable only for aggregators',
		},
	],
	FINGERPRINT: 'FINGERPRINT',
	X_DEVICE_FINGERPRINT: 'X-DEVICE-FINGERPRINT',
	WHITELISTED_URl: [
		'/dashboard',
		'/transactions',
		'/transactions/list',
		'/transactions/reports',
		'/transactions/details/[\\w%-]+',
		'/transactions/dailyReports',
		'/refunds',
		'/refunds/details/[\\w%-]+',
		'/refunds/past-refunds',
		'/refunds/initiate',
		'/refunds/reports',
		'/refunds/dailyReports',
		'/settlements',
		'/qr',
		'/qr/enabledQR',
		'/qr/disabledQR',
		'/store',
		'/store/list',
		'/store/details/[\\w%-]+/[\\w%-]+',
		'/faq',
		'/team',
		'/profile',
	],
	MERCHANT_GROUP_NAME: 'merchant',
	SUPERMERCHANT_GROUP_NAME: 'supermerchant',
	X_CSRF_TOKEN: 'x-csrf-token',
	X_CSRF_COOKIE: '_X52F70K3N', // Random cookie name to keep the cookie name non trackable.
	FINGERPRINT_COOKIE: '_F1P21N7',
	SUB_URL_INSIGHTS: '/mi-web',
	SUB_URL_OM_INSIGHTS: '/omx-web',
	SUB_URL_IRISMX: '/irismx-web',
	SUB_URL_IRIS: '/iris-web',
	SUB_URL_ATHENA: '/athena-web',
	SUB_URL_EARNEST: '/earnest-web',
	SUB_URL_MERCHANT_ONBOARDING: '/mo-web',
	SUB_URL_UIL: '/unified-ingestion',
	SUB_URL_CHIMERA: '/chimera-web',
	SUB_URL_BRICKBAT: '/brickbat-web',
	SUB_URL_VALHALLA: '/valhalla-web',
	SUB_URL_SIMULATOR: '/merchant-simulator-web',
	ONBOARDING_STAGE: {
		ACTIVE: 'ACTIVE',
	},
	TRACKER_ID_OFFLINE_DASHBOARD: 'PHONEPE_MERCHANT_OFFLINE',
	TRACKER_ID_ONLINE_DASHBOARD: 'PHONEPE_MERCHANT_ONLINE',
	ONBOARDING_TYPE: {
		SELF: 'Self',
	},
	FILTERS_DISPLAY_DATE_FORMAT: 'DD MMM YYYY',
	FILTERS_FUNCTIONAL_DATE_FORMAT: 'YYYY-MM-DD',
	FILTERS_TIME_FORMAT: 'HH:mm',
	PAYLINK_PAGE_SIZE: 20,
	PAYLINK_DATE_DISPLAY_FORMAT: 'DD MMM’YY | hh:mm A',
	SUPERMID_SELECTION_ROUTES: {
		singleSelection: ['paylinks', 'settlements', 'myStores', 'mappedQRCodes'],
		multiSelection: [
			'dashboard',
			'txnHistoryList',
			'refundsList',
			'refundsGenerateReport',
		],
	},
	REPORT_STATUS: {
		SETTLEMENT_COMPLETED: 'SETTLEMENT_COMPLETED',
		REPORT_NOT_READY_TO_BE_GENERATED: 'REPORT_NOT_READY_TO_BE_GENERATED',
		DATA_INGESTION_COMPLETED: 'DATA_INGESTION_COMPLETED',
		TO_BE_STARTED: 'TO_BE_STARTED',
		IN_PROGRESS: 'IN_PROGRESS',
		SUCCESSFUL: 'SUCCESSFUL',
		FAILED: 'FAILED',
	},

	API_KEYS_DISPLAY_TIME: 60, // in seconds
	API_KEY_DISPLAY_STATE: {
		IN_PROCESS: 'In Process',
		GENERATED: 'Generated',
	},
	HCAPTCHA_SITE_KEY: process.env.HCAPTCHA_SITE_KEY as string,
	HCAPTCHA_SCRIPT_SOURCE: process.env.HCAPTCHA_SCRIPT_SOURCE as string,
	HCAPTCHA_HOST: process.env.HCAPTCHA_HOST as string,
	GTM_CONSOLE_ID: process.env.GTM_CONSOLE_ID as string,
	BRICKBAT_SURVEY_LINK: process.env.BRICKBAT_SURVEY_LINK as string,
	HCAPTCHA_HEADER_KEY: 'h-captcha-token',
	SAFE_STRING_MI_MAX_LENGTH: 63,
	MERCHANT_CONFIG_TYPE: {
		FEATURE_CONFIG: 'FeatureConfig',
	},
	WEBSITE_TYPES: [
		{
			displayName: 'Shopify',
			value: 'SHOPIFY',
		},
		{
			displayName: 'WooCommerce',
			value: 'WOOCOMMERCE',
		},
		{
			displayName: 'OpenCart',
			value: 'OPENCART',
		},
		{
			displayName: 'Other/Custom',
			value: 'CUSTOM',
		},
	],
	SHOPIFY_WEBSITE: 'SHOPIFY',
	STORE_HOSTED_TYPES: {
		WEB: 'Web',
		ANDROID: 'Android',
		IOS: 'iOS',
	},
	PG_STEPPER_STATE: {
		IN_PROGRESS: 'IN_PROGRESS',
		PENDING: 'PENDING',
		COMPLETED: 'COMPLETED',
	},
	URL_REGEX:
		/^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?::\d{2,5})?(?:\/[^\s]*)?$/,
	UNUSABLE_DOMAINS_REGEX: new RegExp(
		`^(?!.*\\b(${[
			'phonepe.com',
			'instagram.com',
			'google(?:.com|pay.com|.play.com)',
			'phonepay(?:.com)',
			'phonepe',
			'facebook.com',
			'whatsapp.com',
			'shopify(?:.com|.admin.com|.myshopify.com)',
			'youtube.com',
			'ippbonline.com',
			'paytm.com',
			'phon.pe',
			'phonepay',
			'gmail.com',
			'phone(?:.pe|.com|me.com|pebusiness.com|pe.in)',
			'myshopify.com',
			'phonpe.com',
			'docs.google.com',
			'mydukaan.io',
			'amazon.com',
			'telegram.com',
			'flipkart.com',
			'myshopprime.com',
			'in.com',
			'sites.google.com',
			'socpanel.com',
			'wa.me',
			'gpay.com',
			'sbi.com',
			'abc.com',
			'gogel.com',
			'google',
			'phonepebusiness.com',
		].join('|')})\\b).*`,
		'i',
	),
	INVALID_WEBSITE_APPSTORE_URL_REGEX: new RegExp(
		`^.*(play.google.com/|apps.apple.com/|indusappstore.com/).+$|^(?!.*\\b(${[
			'phonepe.com',
			'instagram.com',
			'google(?:.com|pay.com|.play.com)',
			'phonepay(?:.com)',
			'phonepe',
			'facebook.com',
			'whatsapp.com',
			'shopify(?:.com|.admin.com|.myshopify.com)',
			'youtube.com',
			'ippbonline.com',
			'paytm.com',
			'phon.pe',
			'phonepay',
			'gmail.com',
			'phone(?:.pe|.com|me.com|pebusiness.com|pe.in)',
			'myshopify.com',
			'phonpe.com',
			'docs.google.com',
			'mydukaan.io',
			'amazon.com',
			'telegram.com',
			'flipkart.com',
			'myshopprime.com',
			'in.com',
			'sites.google.com',
			'socpanel.com',
			'wa.me',
			'gpay.com',
			'sbi.com',
			'abc.com',
			'gogel.com',
			'google',
			'phonepebusiness.com',
		].join('|')})\\b).*`,
		'i',
	),
	APP_PACKAGE_REGEX: /^([a-z0-9_]+\.[a-z0-9_]+)+$/i,
	PAYMENT_SOLUTION: {
		B2B_PG: 'B2B_PG',
	},
	PAYMENT_SOLUTION_STATUS: {
		NOT_INITIATED: 'NOT_INITIATED',
		IN_PROGRESS: 'IN_PROGRESS',
		SUCCESS: 'SUCCESS',
		FAILED: 'FAILED',
	},
	SERVICE_ONBOARDING_TYPE: {
		SELF: 'SELF',
	},
	ACCOUNT_MIGRATION_STATUS: {
		PV_ONBOARDING_VERIFICATION_FAILED: 'PV_ONBOARDING_VERIFICATION_FAILED',
	},
	ONLINE_MERCHANT_ONBOARDING_VERIFICATION:
		'ONLINE_MERCHANT_ONBOARDING_VERIFICATION',
	KYC_INIT_VERSION: '1.0.0',
	PV_SDK_BASE_URL: process.env.REACT_APP_KYC_SDK_BASE_URL,
	KYC_SDK_ACTIONS: {
		SUBMIT_TRIGGERED: 'SUBMIT_TRIGGERED',
		TERMINAL_ACTION: 'TERMINAL_ACTION',
		PAGE_VIEW: 'PAGE_VIEW',
		KYC_POLLING_TIMEOUT: 'KYC_POLLING_TIMEOUT',
		SUBMIT_FAILED: 'SUBMIT_FAILED',
		KYC_COMPLETED: 'KYC_COMPLETED',
		SUBMIT_COMPLETED: 'SUBMIT_COMPLETED',
	},
	PG_ACTIVATION_REDIRECTION_TIME: 5, // in seconds
	KYC_STEPS: {
		BUSINESS_DETAILS: 'BUSINESS_DETAILS',
		KYC_COMPLETED: 'KYC_COMPLETED',
		BANK_SECTION: 'BANK_SECTION',
		GST_PAN_SECTION: 'GST_PAN_SECTION',
		GST_PAN_DOCUMENT_UPLOAD_SECTION: 'GST_PAN_DOCUMENT_UPLOAD_SECTION',
	},
	KYC_STATUS: {
		PENDING: 'PENDING',
		IN_PROGRESS: 'IN_PROGRESS',
		COMPLETED: 'COMPLETED',
		PSEUDO_SUCCESS: 'PSEUDO_SUCCESS',
		ERROR: 'ERROR',
	},
	ALPHA_NUMERIC_REGEX: /^[a-zA-Z0-9\s]*$/,
	POSITIVE_NUMBER_REGEX: /^[1-9]\d*$/,
	ALPHA_NUMERIC_NO_SPACE_REGEX: /^\w+$/,
	ALPHA_NUMERIC_BOTH_REGEX: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]*$/,
	BUSINESS_LINES: {
		B2B_PG: 'B2B_PG',
		MASS: 'MASS',
	},
	PG_UTM_SOURCES: [
		'pp_website_organic_redirect',
		'pp_website_organic_redirect_payment_link',
		'website_pricing_LP',
		'website_LP_UPI',
		'website_LP_shopify',
		'website_LP_woocommerce',
		'website_LP_opencart',
		'website_LP_ecommerce',
	],
	SERVICE_LINE: {
		PAYMENT_GATEWAY: 'PAYMENT_GATEWAY',
		PAYMENT_LINK: 'PAYMENT_LINK',
	},
	SOURCE_IDENTIFIER: {
		UTM_SOURCE: 'utm_source',
		ENCODED_SOURCE_META: 'encoded-source-meta',
	},
	ADDRESS_REGEX: /^[a-zA-Z0-9\s,'-]*$/,
	DOCUMENTS_TYPES: {
		DISCLAIMER: 'Disclaimer',
		DISCLAIMER_TNC: 'Terms and Conditions',
		DISCLAIMER_REFUND: 'Refund Policy',
		DISCLAIMER_RETURN: 'Return Policy',
		DISCLAIMER_SHIPPING: 'Shipping Policy',
		DISCLAIMER_PRIVACY: 'Privacy Policy',
	} as Record<string, string>,
	REGISTER_FAILURE_MSG: {
		BANK_VERIFICATION_FAILED:
			'Your KYC verification has failed. Please try again',
		OTP_INVALID: 'Enter the correct OTP.',
		INVALID_OTP: 'Enter the correct OTP.',
		OTP_EXPIRED: 'OTP Expired',
		SUBMIT_FAILED: `We are not able to process your request. Please write to us at 'merchant-pgsupport@phonepe.com'`,
		ATTEMPTS_EXHAUSTED: `Attempts Exhausted`,
	} as Record<string, string>,
	BRICKBAT_SURVEY_NAMESPACE: 'BUSINESSAPP',
	MAX_MIRA_SCAN_RETRY: 30,
	MIRA_POLLING_INTERVAL: 3000,
	PG_RATE: '1.95%',
	LOGIN_REDIRECTION_KEY: 'LOGIN_REDIRECTION',
	LOGIN_REDIRECT_TIME: 10,
	CC_RATE_LIST: [
		{
			type: 'Credit Card (Amex)',
			rate: '2.9%',
		},
		{
			type: 'Credit Card (Diners)',
			rate: '2.9%',
		},
		{
			type: 'Credit Card (Corporate)',
			rate: '2.9%',
		},
	],
	PARTNER_V1: 'PARTNER_V1',
	VERIFICATION_STATUS: {
		SUCCESS: 'SUCCESS',
		FAILED: 'FAILED',
	},
	TEST_MODE_AUTH_KEY: 'TEST_MODE_AUTH',
	PG_TEST_KEY: 'API_TEST_KEY',
	PG_PROD_KEY: 'API_PROD_KEY',
	FRA_URLS_MAX_LENGTH: 255,
});

export const SUBSCRIPTION_SETUP_CONTEXT = 'SUBSCRIPTION_SETUP_CONTEXT';
export const SUBSCRIPTION_SETUP_CONTEXT_V1 = 'SUBSCRIPTION_SETUP_CONTEXT_V1';
export const SUBSCRIPTION_REDEMPTION_CONTEXT =
	'SUBSCRIPTION_REDEMPTION_CONTEXT';
export const SUBSCRIPTION_REDEMPTION_CONTEXT_V1 =
	'SUBSCRIPTION_REDEMPTION_CONTEXT_V1';
export const STORE_IMAGE_PREV_OPTION_CLICKED =
	'STORE_IMAGE_PREV_OPTION_CLICKED';
export const STORE_IMAGE_NEXT_OPTION_CLICKED =
	'STORE_IMAGE_NEXT_OPTION_CLICKED';
export const TRANSACTION_REPORT_DATE_FILTER_SELECTED =
	'TRANSACTION_REPORT_DATE_FILTER_SELECTED';
export const REFUND_REPORT_DATE_FILTER_SELECTED =
	'REFUND_REPORT_DATE_FILTER_SELECTED';
